<template>
  <div class="scode-wrapper">
    <div class="scode-header">
      <img class="img" src="~@/assets/images/super/bg.png" alt="">
    </div>
    <div class="scode-body">
      <div class="scode-code">
        <img class="codeimg" :src="codeUrl" alt="" @click="handlePreview">
      </div>
      <div class="scode-btn-wrapper">
        <button id="codeBtn" class="scode-btn" :data-clipboard-text="codeUrl" @click="handleCopy">复制二维码链接</button>
      </div>
    </div>
    <div class="scode-tip">
      <p>1.可直接将此页面截屏后，在电子屏幕上放映供用户扫描登记；</p>
      <p>2.如需打印二维码，可点击复制二维码链接按钮后，使用手机浏览器打开，长按下载二维码；或者复制二维码链接后，发送到电脑，使用浏览器打开，下载图片并打印。</p>
    </div>
  </div>
</template>
<script>
import { Toast, ImagePreview } from 'vant'
import ClipboardJS from 'clipboard'
import { getCode } from '@/api/super'
import { setStore, removeStore } from '@/utils/index'

export default {
  data () {
    return {
      show: false,
      codeUrl: '',
      detailId: '下载二维码'
    }
  },
  mounted () {
    this.detailId = this.$route.query.detailId
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
      this.token = token
    }
    this.getUrl(this.detailId)
  },
  destroyed () {
    removeStore('token')
  },
  methods: {
    handlePreview () {
      if (this.codeUrl) {
        ImagePreview({
          images: [
            this.codeUrl
          ],
          showIndex: false,
          closeable: true
        })
      }
    },
    getUrl (id) {
      getCode(id).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          const { qrCodeUrl } = res.data.result
          this.codeUrl = qrCodeUrl
        }
      }).catch(() => {

      })
    },
    handleCopy () {
      let clipboard = new ClipboardJS('#codeBtn')
      clipboard.on('success', e => {
        Toast({
          message: '复制成功'
        })
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        Toast({
          message: '复制失败'
        })
        clipboard.destroy()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.scode-wrapper {
  min-height: 100vh;
  background: #f7f7f7;
}
.scode-header {
  .img {
    width: 100%;
  }
}
.scode-body {
  position: relative;
  top: -20px;
  border-radius: 10px;
  background: #fff;
  margin: 0 15px 15px 15px;
  padding: 30px 15px;
}
.scode-code {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  min-height: 160px;
  .codeimg {
    width: 150px;
    height: 150px;
  }
}
.scode-desc {
  margin: 25px 25px 30px;
  font-size: 14px;
  color: #757575;
  text-align: center;
}
.scode-btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.scode-btn {
  width: 80%;
  padding: 8px 0;
  border-radius: 30px;
  background-color: #4f7cf6;
  font-size: 16px;
  color: #fff;
}
.scode-tip {
  margin-top: -30px;
  padding: 10px 15px;
  color: #757575;
  font-size: 14px;
}
</style>
